// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen {
  .select-list-item-select {
    position: fixed;
    z-index: 1000;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    transform: translateX(100%);
    transition: all ease-out 0.3s;
    overflow-y: hidden;
    height: 100%;
  }
  .select-list-item-select.active {
    transform: translateX(0);
  }
  .parameters-values {
    margin-top: 56px;
    padding: 0 1rem;
    height: calc(100% - 56px);
    overflow-y: scroll;
  }
  .parameter-value {
    margin-left: auto;
    margin-right: auto;
  }
  .parameter-value .select-list-container:after {
    display: none;
  }
  .attr-value.selected {
    color: var(--dms-color);
  }
  .label {
    display: inline-block;
    width: auto;
  }
  .select-list-container.label {
    max-width: xrem(80px);
    float: left;
    text-align: center;
    display: inline-block;
    color: var(--dms-color);
    font-size: xrem(12px);
    font-weight: 500;
    letter-spacing: xrem(-0.4px);
    line-height: 1.05;
    padding: xrem(18px) 0;
    vertical-align: middle;
    cursor: pointer;
  }
  .select-list-container.label:first-child {
    text-align: left;
  }
  .select-list-container.label:last-child {
    width: xrem(30px);
    text-align: right;
    padding-right: xrem(3px);
    margin-right: 0;
    float: right;
  }
  .select-list-component-compact {
    width: 100%;
    font-size: 14px;
    color: var(--mc-select-text);
    text-align: left;
  }
  .select-list-container.compact {
    text-align: left;
  }
  .select-list-container.compact:after {
    speak: none;
    font-family: "icomoon" !important;
    content: "\\e409";
    position: absolute;
    right: 0px;
    font-size: 24px;
    font-weight: 300;
    color: var(--mc-select-icon);
    top: -5px;
  }
  i.icon-keyboard_arrow_down {
    font-size: 16px;
  }
  .attr-label {
    color: var(--mc-text-2d);
  }
  .attr-label .selected {
    font-weight: 500;
  }
  .attr-label .sublabel {
    padding-left: 10px;
    font-weight: 400;
    opacity: 0.6;
  }
  .hidden {
    display: none;
  }
  .loading {
    opacity: 0.5;
  }
}
/* min-width 375px, small screens */
@media only screen and (min-width: 375px) {
  .select-list-container.label {
    font-size: xrem(14px);
    width: auto;
    margin-right: xrem(24px);
    max-width: none;
  }
  .select-list-container.label:last-child {
    width: auto;
    float: right;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/select-list/select-list-lazy.component.scss"],"names":[],"mappings":"AAEA;EACI;IACI,eAAA;IACA,aAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,SAAA;IACA,2BAAA;IACA,6BAAA;IACA,kBAAA;IACA,YAAA;EADN;EAIE;IACI,wBAAA;EAFN;EAKE;IACI,gBAAA;IACA,eAAA;IACA,yBAAA;IACA,kBAAA;EAHN;EAME;IACI,iBAAA;IACA,kBAAA;EAJN;EAOU;IACI,aAAA;EALd;EAcE;IACI,uBAAA;EAZN;EAeE;IACI,qBAAA;IACA,WAAA;EAbN;EAgBC;IACK,qBAAA;IACA,WAAA;IACA,kBAAA;IACA,qBAAA;IACA,uBAAA;IACA,qBAAA;IACA,gBAAA;IACA,4BAAA;IACA,iBAAA;IACA,qBAAA;IACA,sBAAA;IACA,eAAA;EAdN;EAoBM;IACI,gBAAA;EAlBV;EAqBM;IACI,iBAAA;IACA,iBAAA;IACA,wBAAA;IACA,eAAA;IACA,YAAA;EAnBV;EAsBE;IACI,WAAA;IACA,eAAA;IACA,4BAAA;IACA,gBAAA;EApBN;EAsBE;IACI,gBAAA;EApBN;EAqBM;IACI,WAAA;IACA,iCAAA;IACA,gBAAA;IACA,kBAAA;IACA,UAAA;IACA,eAAA;IACA,gBAAA;IACA,4BAAA;IACA,SAAA;EAnBV;EAuBE;IACI,eAAA;EArBN;EAuBE;IACI,wBAAA;EArBN;EAsBM;IACI,gBAAA;EApBV;EAsBM;IACI,kBAAA;IACA,gBAAA;IACA,YAAA;EApBV;EAwBE;IACI,aAAA;EAtBN;EAyBD;IACC,YAAA;EAvBA;AACF;AA0BA,mCAAA;AACA;EACI;IACI,qBAAA;IACA,WAAA;IACA,wBAAA;IACA,eAAA;EAxBN;EA2BM;IACI,WAAA;IACA,YAAA;EAzBV;AACF","sourcesContent":["\r\n\r\n@media only screen {\r\n    .select-list-item-select {\r\n        position: fixed;\r\n        z-index: 1000;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        transform: translateX(100%);\r\n        transition: all ease-out 0.3s;\r\n        overflow-y: hidden;\r\n        height: calc(100%);\r\n    }\r\n\r\n    .select-list-item-select.active {\r\n        transform: translateX(0);\r\n    }\r\n\r\n    .parameters-values {\r\n        margin-top: 56px;\r\n        padding: 0 1rem;\r\n        height: calc(100% - 56px);\r\n        overflow-y: scroll;\r\n    }\r\n\r\n    .parameter-value {\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n\r\n        .select-list-container {\r\n            &:after {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        // &.all .select-list-container:before {\r\n        //     display: none;\r\n        // }\r\n    }\r\n\r\n    .attr-value.selected {\r\n        color: var(--dms-color);\r\n    }\r\n\r\n    .label {\r\n        display: inline-block;\r\n        width: auto;\r\n    }\r\n\r\n   .select-list-container.label {\r\n        max-width: xrem(80px);\r\n        float: left;\r\n        text-align: center;\r\n        display: inline-block;\r\n        color: var(--dms-color);\r\n        font-size: xrem(12px);\r\n        font-weight: 500;\r\n        letter-spacing: xrem(-0.4px);\r\n        line-height: 1.05;\r\n        padding: xrem(18px) 0;\r\n        vertical-align: middle;\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n\r\n        }\r\n\r\n        &:first-child {\r\n            text-align: left;\r\n        }\r\n\r\n        &:last-child {\r\n            width: xrem(30px);\r\n            text-align: right;\r\n            padding-right: xrem(3px);\r\n            margin-right: 0;\r\n            float: right;\r\n        }\r\n    }\r\n    .select-list-component-compact {\r\n        width: 100%;\r\n        font-size: 14px;\r\n        color: var(--mc-select-text);\r\n        text-align: left;\r\n    }\r\n    .select-list-container.compact {\r\n        text-align: left;\r\n        &:after {\r\n            speak: none;\r\n            font-family: 'icomoon' !important;\r\n            content: \"\\e409\";\r\n            position: absolute;\r\n            right: 0px;\r\n            font-size: 24px;\r\n            font-weight: 300;\r\n            color: var(--mc-select-icon);\r\n            top: -5px;\r\n        }\r\n    }\r\n\r\n    i.icon-keyboard_arrow_down {\r\n        font-size: 16px;\r\n    }\r\n    .attr-label {\r\n        color: var(--mc-text-2d);\r\n        .selected {\r\n            font-weight: 500;\r\n        }\r\n        .sublabel {\r\n            padding-left: 10px;\r\n            font-weight: 400;\r\n            opacity: 0.6;\r\n        }\r\n    }\r\n\r\n    .hidden {\r\n        display:none;\r\n    }\r\n\r\n\t.loading {\r\n\t\topacity: 0.5;\r\n\t}\r\n\r\n}\r\n/* min-width 375px, small screens */\r\n@media only screen and (min-width: 375px) {\r\n    .select-list-container.label {\r\n        font-size: xrem(14px);\r\n        width: auto;\r\n        margin-right: xrem(24px);\r\n        max-width: none;\r\n\r\n\r\n        &:last-child {\r\n            width: auto;\r\n            float: right;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
